import { render, staticRenderFns } from "./SaldoSalida.vue?vue&type=template&id=034bc9e6"
import script from "./SaldoSalida.vue?vue&type=script&lang=js"
export * from "./SaldoSalida.vue?vue&type=script&lang=js"
import style0 from "./SaldoSalida.vue?vue&type=style&index=0&id=034bc9e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports